import {AxiosResponse} from 'axios';
import Api from '../api';

export default (requestBody): Promise<AxiosResponse> => {
    const path = '/taxonomy-api/v2/recently-viewed';

    return Api.getInstance(false, false, process.env.REACT_APP_API_SUB_URL).request.post(`${path}`, requestBody, path);
};
